import React, { type JSX } from "react";
import { type Toast, type ToastPosition } from "react-hot-toast/headless";
import { twMerge } from "tailwind-merge";

interface ToastBarProps {
  toast: Toast;
  position?: ToastPosition;
  style?: React.CSSProperties;
  renderToast?: (toast: Toast) => JSX.Element;
}

const getAnimationStyle = (position: ToastPosition, visible: boolean): React.CSSProperties => {
  const top = position.includes("top");
  const [enter, exit] = [top ? "enterAnimationTop" : "enterAnimationBottom", top ? "exitAnimationTop" : "exitAnimationBottom"];

  return {
    animation: visible ? `${enter} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${exit} 0.4s forwards cubic-bezier(.06,.71,.55,1)`,
  };
};

export function ToastBar({ toast, position, style, renderToast }: ToastBarProps) {
  const animationStyle: React.CSSProperties = toast.height ? getAnimationStyle(toast.position ?? position ?? "top-center", toast.visible) : { opacity: 0 };

  return (
    <div
      className={twMerge("sup-toast-bar flex items-center will-change-transform pointer-events-auto", toast.className)}
      style={{
        ...animationStyle,
        ...style,
        ...toast.style,
      }}
    >
      {renderToast?.(toast)}
    </div>
  );
}
